import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IAccount } from 'models/Account';
import Cookies from 'js-cookie';
import i18 from '../../i18n/index';
import AuthServiceApi from 'apis/api/Auth';
import EnDeAES from 'helpers/EnDeAES';
import { MINPAGESIZE } from 'global/Global';

import { routes, RouteProps } from '@lib/routes';

export const getUserCurrent = createAsyncThunk('user/Current', async () => {
  try {
    const response = await AuthServiceApi.GetRoleV2();
    const dateEn = EnDeAES.encodeBase64(EnDeAES.aesEncrypt(JSON.stringify(response.data.data)));
    localStorage.setItem('role', dateEn);
    localStorage.setItem('roleDev', JSON.stringify(response.data.data));
    return response.data;
  } catch (error) {
    throw new Error('');
  }
});

export enum LanguageSelectType {
  VIETNAM = 'VIETNAM',
  ENGLISH = 'ENGLISH'
}

// Cài đặt table setting cho column
export type TTableColumnSetting = {
  tableName: string;
  columnHidden: Array<string>;
  columnSize: Array<string>;
  hiddenAuto?: boolean;
};

// Cài đặt table
export type TTableSetting = {
  userName?: string;
  fontSize: string;
  sizePage: number;
  fontStyle: string;
  stripe: boolean;
  autoSaveColumnHidden: boolean;
  autoSaveColumnWidth: boolean;
  resizingMode: string;
  tableColumnSetting: Array<TTableColumnSetting>;
};

type initialStateType = {
  //   userLogin?: IAccount,
  routesFilter?: any[];
  deviceTokenMessage: any;
  userLoginTest?: Array<IAccount>;
  userName?: string;
  isSuccessLogin: boolean;
  language: LanguageSelectType;
  tableSetting: TTableSetting;
  account: IAccount | undefined;
  canCollectCash?: any;
  userAccountTax?: any;
  avatar?: any;
  token?: string;
  roleTag?: string;
  openSettingTable?: boolean;
};

// Mặc định table
export const initialSettingTable = {
  fontSize: '11.5px',
  sizePage: MINPAGESIZE,
  fontStyle: 'normal',
  stripe: true,
  autoSaveColumnHidden: true,
  autoSaveColumnWidth: true,
  resizingMode: 'widget',
  tableColumnSetting: []
};

const checkItemAccess = (item: RouteProps, roleName: string, isHead?: boolean) => {
  // 1. Kiểm tra lớp OnlyHead
  const passHead =
    item.onlyHead && item.onlyHead.length > 0 ? checkAcceptOnLyHeadOf(roleName, item.onlyHead, isHead) : false; // Nếu không có onlyHead thì coi như không pass lớp này

  // 2. Kiểm tra lớp RoleAccepts
  const passRole = checkAcceptRoleTag(roleName, item.RoleAccepts);

  // LOGIC "HOẶC": Chỉ cần pass 1 trong 2 là HIỆN (trả về true)

  return passHead || passRole;
};

const checkAcceptRoleTag = (roleTag: string, Roles: any[]) => {
  // console.log('check role', Roles, roleTag);
  return !Roles || Roles.includes(roleTag);
};

const checkAcceptOnLyHeadOf = (roleTag: string, Roles: any[], isHead?: boolean) => {
  // console.log('ey', roleTag, Roles, isHead, Roles.includes(roleTag) && isHead);
  return Roles.includes(roleTag) && (isHead || roleTag === 'BranchManager');
};

// hiện tại chỉ xử lý tới bậc 3 thôi, nếu cần thêm thì xử lý tiếp.. nhưng menu bar thì ít khi làm quá 3 bậc
// const handleCheckChildLv3 = (childListLv3: RouteProps[], roleTag: string, filterMenus: any[], isHead?: boolean) => {
//   let notUse = true;
//   for (let i = 0; i < childListLv3.length; i++) {
//     const item = childListLv3[i];

//     const passHead =
//       item.onlyHead && item.onlyHead.length !== 0 ? checkAcceptOnLyHeadOf(roleTag, item.onlyHead, isHead) : false;

//     const passRole = checkAcceptRoleTag(roleTag, item.RoleAccepts);

//     const hasAccess = passHead || passRole;

//     if (!hasAccess) {
//       filterMenus.push(item.key);
//     } else {
//       notUse = false; // Có ít nhất 1 item bậc 3 hiển thị được

//       // Nếu sau này cần lv 4 thì gọi đệ quy tiếp ở đây
//       if (item.children && item.children.length > 0) {
//         // Xử lý lv4 nếu cần...
//       }
//     }
//   }
//   return notUse;
// };

const handleCheckChildLv3 = (childListLv3: RouteProps[], roleTag: string, filterMenus, isHead?: boolean) => {
  let notUse = true; // kiểm tra xe có trường hợp list chuld đã bị ẩn hết
  for (let i = 0; i < childListLv3.length; i++) {
    // đi qua các con của menu bậc 3
    // check tiếp lv 3 các con của nó..
    const checkHead =
      childListLv3[i].onlyHead && childListLv3[i].onlyHead.length != 0
        ? checkAcceptOnLyHeadOf(roleTag, childListLv3[i].onlyHead, isHead)
        : true;
    if (!checkHead || !checkAcceptRoleTag(roleTag, childListLv3[i].RoleAccepts)) {
      filterMenus.push(childListLv3[i].key); // cho vào list lọc ra
    } else {
      notUse = false;
      if (childListLv3[i].children) {
        // không có child 3, đi qua xử lý từng con 1
        // có child lv 3
        console.log('lv 3 child', childListLv3[i].children);
        // if (rlt) {
        //   notUse = true;
        //   filterMenus.push(childListLv2[i].key);
        // } else {
        //   notUse = false;
        // }
      }
    }
  }
  return notUse;
};

// const handleCheckChildLv2 = (childListLv2: RouteProps[], roleTag: string, filterMenus: any[], isHead?: boolean) => {
//   let notUse = true;

//   for (let i = 0; i < childListLv2.length; i++) {
//     const item = childListLv2[i];

//     // 1. Kiểm tra lớp OnlyHead
//     const passHead =
//       item.onlyHead && item.onlyHead.length !== 0 ? checkAcceptOnLyHeadOf(roleTag, item.onlyHead, isHead) : false; // Nếu không có onlyHead thì mặc định vế này false

//     // 2. Kiểm tra lớp RoleAccepts
//     const passRole = checkAcceptRoleTag(roleTag, item.RoleAccepts);

//     // LOGIC MỚI: Chỉ cần thỏa mãn 1 trong 2 là có quyền (hasAccess = true)
//     const hasAccess = passHead || passRole;

//     if (!hasAccess) {
//       // Chỉ khi cả 2 đều SAI thì mới chặn
//       filterMenus.push(item.key);
//     } else {
//       // Nếu có quyền, tạm thời cho rằng menu này "có ích" (không bị ẩn sạch)
//       let currentItemHiddenByChildren = false;
//       if (item.children && item.children.length > 0) {
//         // Có con thì check tiếp lv 3
//         const allChildrenHidden = handleCheckChildLv3(item.children, roleTag, filterMenus, isHead);
//         if (allChildrenHidden) {
//           // Nếu tất cả con bị ẩn thì cha cũng ẩn
//           filterMenus.push(item.key);
//           currentItemHiddenByChildren = true;
//         }
//       }

//       if (!currentItemHiddenByChildren) {
//         notUse = false; // Menu này dùng được (không bị ẩn)
//       }
//     }
//   }
//   return notUse;
// };

const handleCheckChildLv2 = (
  childListLv2: RouteProps[],
  roleTag: string,
  filterMenus: any,
  isHead?: boolean,
  canCollectCash?: boolean // Thêm ở đây
) => {
  let notUse = true; // kiểm tra xe có trường hợp list chuld đã bị ẩn hết

  for (let i = 0; i < childListLv2.length; i++) {
    const item = childListLv2[i];

    // XỬ LÝ RIÊNG CHO MENU THU TIỀN
    if (item.key === 'money-management.fee-tracking-page' && canCollectCash) {
      notUse = false; // Có ít nhất 1 cái hiện thì cha (Lv1) sẽ hiện
      continue;
    }

    // đi qua các con của menu bậc 2
    const checkHead =
      item.onlyHead && item.onlyHead.length != 0 ? checkAcceptOnLyHeadOf(roleTag, item.onlyHead, isHead) : true;
    const checkRoleAccepts = checkAcceptRoleTag(roleTag, item.RoleAccepts);

    if (!checkHead && !checkRoleAccepts) {
      filterMenus.push(item.key);
    } else if (!checkHead || !checkRoleAccepts) {
      filterMenus.push(item.key); // cho vào list lọc ra
    } else {
      notUse = false;
      if (item.children) {
        // có child lv 3
        console.log('lv 2 child', item.children);
        const rlt = handleCheckChildLv3(item.children, roleTag, filterMenus, isHead);
        if (rlt) {
          notUse = true;
          filterMenus.push(item.key);
        } else {
          notUse = false;
        }
      }
    }
  }
  return notUse;
};

/**
 * Hàm xử lý check lại phân quyền dựa trên quyền của tk đăng nhập
 * @param roleName Tag quyền
 * @param listRole List quyền từ code source
 * @returns
 */
const handleFilterRouteCanAccess = (
  roleName: string,
  listRole: RouteProps[],
  isHead?: boolean,
  canCollectCash?: boolean, // Tham số mới
  userAccountTax?: boolean // Tham số mới
) => {
  // console.log('FilterRoute', roleName, listRole);
  const filterMenus: any = [];
  // xử lý menu bậc 1
  // for (let i = 0; i < listRole.length; i++) {
  //   const item = listRole[i];
  //   // GỌI HÀM CHECK: passHead HOẶC passRole
  //   const hasAccess = checkItemAccess(item, roleName, isHead);

  //   if (!hasAccess) {
  //     // CHỈ ẩn khi cả 2 điều kiện đều sai
  //     filterMenus.push(item.key);
  //   } else if (item.children) {
  //     // Nếu có quyền (do Head hoặc do Role), kiểm tra tiếp các con
  //     const rlt = handleCheckChildLv2(item.children, roleName, filterMenus, isHead);
  //     if (rlt) {
  //       filterMenus.push(item.key);
  //     }
  //   }
  // }

  for (let i = 0; i < listRole.length; i++) {
    const item = listRole[i];
    // --- CASE 1: XỬ LÝ ĐẶC BIỆT CHO TÀI KHOẢN THUẾ ---
    if (userAccountTax) {
      // Nếu là tài khoản thuế, chỉ cho phép 'report-statistic'
      if (item.key !== 'report-statistic') {
        filterMenus.push(item.key);
        continue; // Bỏ qua các menu cấp 1 khác
      }

      // Kiểm tra các con của 'report-statistic'
      if (item.children) {
        item.children.forEach((child: any) => {
          // Chỉ giữ lại 'report-statistic.ordermanager-page2', còn lại cho vào list ẩn
          if (child.key !== 'report-statistic.ordermanager-page2') {
            filterMenus.push(child.key);
          }
        });
      }
      continue; // Đã xử lý xong logic đặc biệt cho item này
    }

    // TRƯỜNG HỢP ĐẶC BIỆT: Nếu menu cha chứa menu thu tiền
    // Kiểm tra các con bên trong thông qua Lv2
    if (item.key === 'money-management' && canCollectCash) {
      const allChildrenHidden = handleCheckChildLv2(item.children || [], roleName, filterMenus, isHead, canCollectCash);
      if (allChildrenHidden) {
        filterMenus.push(item.key);
      }
      continue; // Đã xử lý xong item này, nhảy sang item tiếp theo
    }

    const checkHead =
      item.onlyHead && item.onlyHead.length != 0 ? checkAcceptOnLyHeadOf(roleName, item.onlyHead, isHead) : true;
    if (!checkHead || !checkAcceptRoleTag(roleName, item.RoleAccepts)) {
      filterMenus.push(item.key); // cho vào list lọc ra
    } else if (item.children) {
      // có list child bậc menu 2
      const rlt = handleCheckChildLv2(item.children, roleName, filterMenus, isHead);
      if (rlt) {
        filterMenus.push(item.key);
      }
    }
  }
  return filterMenus;
};
// sửa lại nếu k có con nào hết thì ẩn luôn menu cha ok
// check ẩn menu trong sider luôn hiddenSider
// ngoài ra check trong Layout luôn, nếu phát hiện nghi vấn khi chọn vào menu k có quyền thì chuyển sang home

const handleAssignRolesAcc = (roleTag: any, state: any) => {
  switch (roleTag) {
    case 'Accountant': // Ke toan
      state.account.ActionOrder = {
        // Đơn thu nợ
        // createOrder: !0,
        createOrderThuNo: true,
        createOrderChenhLech: true,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: false, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: false, // quyền data khách hàng được phép xóa
        permisionBlockCustomer: true, // quyền data khách hàng được phép khóa
        viewPhone: state.account.isHeadOfDepartment ? true : false, // quyền data khách hàng được phép xem do mình tạo
        excelFile: false,
        viewDashBoardKT: true,
        // test kto
        reqEditOrder: !0,
        updateOrder: !0,
        approveOrder: !0,
        declineOrder: !0,
        viewMoreDays: !0,
        editTienThucThu: false,
        viewMap: !0,
        editDetailProductList: !0,
        editVATAfterComplete: true,
        changeUseVATACpl: true, // bật tắt VAT
        viewDetailProductList: !0,
        editMoneyAfterComplete: true,
        // permisionUpdateCustomer: !0, // quyền data khách hàng được phép sửa
        // permisionDeleteCustomer: !0, // quyền data khách hàng được phép xóa
        // permisionViewCustomer: !0, // quyền data khách hàng được phép xem
        alertOrder: !0,
        changeVAT: !0,
        viewPrice: !0,
        editPayOrder: !0,
        editWillPay: !0,
        noViewFeedback: !0,
        reloadInterval: !0,
        // 'Hoàn tiền'
        permisionCreate: ['Thu nợ', 'Chênh lệch'], // 'Thu nợ', Hoàn tiền
        defaultOrder: 0
      };
      state.account.ActionAccount = {
        // new
        isLocked: true,
        // old
        allowEditOrderComplete: false,
        allowEdit: state.account.isHeadOfDepartment ? true : false,
        permissionCreate: ['Accountant']
      };
      state.account.AlertOrder = {
        payedAlert: !0
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };
      // cấu hình các quyền thao tác vào các input trong việc quản lý đơn, đối với kto thì áp dụng toàn trạng thái
      state.account.OFormRightAll = {
        CustomerForm: {
          // UI khách hàng
        },
        ProductSelect: {
          // UI liên quan list summary thiết bị chủ yếu dùng cho đơn base
          editPriceProduct: !1 // không có quyền sửa giá sản phẩm trong list summary
        },
        PaymentForm: {
          // phần thu phí
          EditPromoteFees: !1, // k cho sửa giá khuyến mãi..
          WiewOtherFees: !0, // thấy giá phí khác và công...
          EditOtherFees: !1 // không có quyền edit, chỉ được view
        },
        SubInfoForm: {
          // UI các thông tin khác của đơn như thời gian hẹn, loại đơn...
        },
        StatusForm: {
          // Cập nhật trạng thái đơn
        },
        BaseForm: {
          ViewOrder: !0,
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: !1 // kế toán là k có quyền đụng vô tiền này!
          // UI đơn cơ bản
        },
        FeesForm: {
          // UI đơn thu phí
        },
        SetsForm: {
          // UI đơn theo bộ (ĐL lắp giùm)
        },
        WRForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: !1 // kế toán là k có quyền đụng vô tiền này!
          // UI đơn sc bh
        },
        RLForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: !1 // kế toán là k có quyền đụng vô tiền này!
          // UI đơn tháo lắp
        },
        UpdForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: !1 // kế toán là k có quyền đụng vô tiền này!
          // UI đơn nâng cấp
        }
      };
      break;
    case 'Operating': // Điều hành
      state.account.ActionOrder = {
        viewDashBoardKT: !0,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: false, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: false, // quyền data khách hàng được phép xóa
        excelFile: false,
        // test đh
        checkOnFirst: !0,
        assignOrder: !0,
        selectStaff1: !0,
        alertOrder: !0,
        postpone: !0,
        restartProcess: !0,
        viewDetailProductList: !0,
        editDetailProductList: !0,
        viewStaffAction: !0,
        editWillPay: !1, // tắt quyền chỉnh tiền do tiền này khá quan trọng
        editTienThucThu: false,
        viewAllAction: !0,
        cancelOrder: !0,
        sendOSeen: !0,
        noViewFeedback: !0,
        viewMoreDays: !0 // Xem được 31 ngày ở các báo cáo
      };
      state.account.ActionAccount = {
        // new
        isLocked: false,
        // old
        allowEditOrderComplete: false,
        allowEdit: state.account.isHeadOfDepartment ? true : false,
        allowEditOther: ['Technician'],
        permissionCreate: ['Operating', 'Technician']
      };
      state.account.AlertOrder = {
        sameCusAlert: !0
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };
      state.account.OFormRightAll = {
        ProductSelect: {
          editPriceProduct: !1 // không có quyền sửa giá sản phẩm trong list summary
        },
        PaymentForm: {
          EditPromoteFees: !1, // k cho sửa giá khuyến mãi..
          EditOtherFees: !1
        }
      };
      break;
    case 'Sale': // Kinh doanh
      state.account.ActionOrder = {
        viewDashBoardKD: !0,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: !0, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: !0, // quyền data khách hàng được phép xóa
        viewPhone: true, // sale đc thấy sđt kh trừ là tp thì chỉ thấy những kh họ có trong list ql
        excelFile: false,
        // test Sale
        viewPrice: !0,
        reqEditOrder: !0,
        updateOrder: !0,
        createOrder: !0,
        alertOrder: !0,
        cancelOrder: !0,
        viewMoreDays: !0,
        editDetailProductList: !0,
        reOrder: !0,
        changeUseVATACpl: false, // bật tắt VAT
        editVATAfterComplete: state.account.isHeadOfDepartment ? true : false,
        editMoneyAfterComplete: state.account.isHeadOfDepartment ? true : false,
        cancelOrderAfterComplete: state.account.isHeadOfDepartment ? true : false,
        changeVAT: !0,
        editWillPay: !0,
        editPayOrder: !0,
        checkOnFirst: !0,
        editTienThucThu: false,
        noViewFeedback: !0,
        permisionCreate: ['Hàng gửi', 'Lắp mới', 'Thu đổi', 'Nâng cấp', 'Tháo - Lắp lại', 'ĐL lắp giùm', 'Lắp giùm ĐL'], // Thêm đơn tháo - lắp lại
        defaultOrder: 1 // stt dựa trên list permisionCreate
      };
      state.account.ActionAccount = {
        // new
        isLocked: false,
        // old
        allowEdit: state.account.isHeadOfDepartment ? true : false,
        allowEditOrderComplete: state.account.isHeadOfDepartment ? true : false,
        permissionCreate: ['Sale']
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };

      // cấu hình các quyền thao tác vào các input trong việc quản lý đơn, chỉ dùng khi đơn đã hoàn tất, trước đó thì k cần check
      state.account.OFormRightCpl = {
        AllForm: {
          ItemSummaries: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa đơn khi đã hoàn tất
        },
        WRForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn sc bh
        },
        RLForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn tháo lắp
        },
        UpdForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn nâng cấp
        },
        BaseForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn base
        }
      };

      break;
    case 'CustomerService': // CSKH
      state.account.ActionOrder = {
        viewDashBoardCSKH: !0,
        // new
        permissionsCheckTrungBS: !0, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: !0, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: !0, // quyền data khách hàng được phép xóa
        excelFile: false,
        // test CustomerService
        viewPrice: !0,
        reqEditOrder: !0,
        updateOrder: !0,
        createOrder: !0,
        alertOrder: !0,
        cancelOrder: !0,
        viewMoreDays: !0,
        reOrder: !0,
        changeUseVATACpl: false, // bật tắt VAT
        editVATAfterComplete: state.account.isHeadOfDepartment ? true : false,
        editMoneyAfterComplete: state.account.isHeadOfDepartment ? true : false,
        cancelOrderAfterComplete: state.account.isHeadOfDepartment ? true : false,
        editTienThucThu: !0,
        changeVAT: !0,
        checkInWarranty: !0,
        editWillPay: !0,
        editPayOrder: !0,
        checkOnFirst: !0,
        sendFeedback: !0,
        viewDetailProductList: !0,
        editDetailProductList: !0,
        permisionCreate: ['Hàng gửi', 'Thu phí', 'Sửa chữa', 'Bảo hành', 'Nâng cấp', 'Tháo - Lắp lại'],
        defaultOrder: 0, // stt dựa trên list permisionCreate
        reloadInterval: !0
      };
      state.account.ActionAccount = {
        // new
        isLocked: false,
        // old
        allowEdit: state.account.isHeadOfDepartment ? true : false,
        allowEditOrderComplete: state.account.isHeadOfDepartment ? true : false,
        permissionCreate: ['CustomerService']
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };
      state.account.OFormRightCpl = {
        AllForm: {
          ItemSummaries: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa đơn khi đã hoàn tất
        },
        WRForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn sc bh
        },
        RLForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn tháo lắp
        },
        UpdForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn nâng cấp
        },
        BaseForm: {
          EditProduct: !1, // không cho đổi sản phẩm đang có
          EditPrice: state.account.isHeadOfDepartment ? true : false // tp thì có thể sửa tiền khi đã hoàn tất
          // UI đơn base
        }
      };

      break;
    case 'Technician': // Kỹ thuật
      state.account.ActionOrder = {
        // createOrder: state.account.isGuiHang ? true : false,
        // updateOrder: state.account.isGuiHang ? true : false,
        checkOnFirst: !0,
        viewDashBoardKTH: !0,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: false, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: false, // quyền data khách hàng được phép xóa
        excelFile: false,
        editProductWorking: !0,
        // test Technician
        alertOrder: !0,
        workingOrder: !0,
        finishOrder: !0,
        completeOrder: !0,
        viewDetailProductList: !0,
        editDetailProductList: !0,
        EnterDetail: !0,
        RepairDevice: !0,
        viewStaffAction: !0,
        noViewFeedback: !0,
        editWillPay: !1, // tắt quyền chỉnh tiền do tiền này khá quan trọng
        editTienThucThu: !0,
        editPayOrder: !0,
        permisionCreate: ['Trả hàng'],
        defaultOrder: 0,
        postpone: !0, // kth cũng cho hoãn lại đơn
        showLessPayment: !0
      };
      state.account.ActionAccount = {
        // new
        isLocked: false,
        // old
        allowEditOrderComplete: false,
        allowEdit: state.account.isHeadOfDepartment ? true : false,
        permissionCreate: ['Technician']
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };
      break;
    case 'WareHouse': // Quản lý kho
      state.account.ActionOrder = {
        // createOrder: !0,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: false, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: false, // quyền data khách hàng được phép xóa
        excelFile: false,
        // test WareHouse
        alertOrder: !0,
        workingOrder: !0,
        finishOrder: !0,
        completeOrder: !0,
        viewDetailProductList: !0,
        editDetailProductList: !0,
        EnterDetail: !0,
        RepairDevice: !0,
        viewStaffAction: !0,
        noViewFeedback: !0,
        editWillPay: !0,
        editTienThucThu: false,
        editPayOrder: !0,
        // permisionCreate: ['Trả hàng'],
        postpone: !0 // kth cũng cho hoãn lại đơn
      };
      state.account.ActionAccount = {
        // new
        isLocked: false,
        // old
        allowEdit: state.account.isHeadOfDepartment ? true : false,
        allowEditOrderComplete: false,
        permissionCreate: ['WareHouse'],
        allowChangeHeadOff: !0
      };
      state.account.defaultMenu = {
        keysMenu: 'report-statistic.report-inout-stock',
        openTabs: ['report-statistic.report-inout-stock', 'report-statistic']
      };
      break;
    case 'BranchManager': // Quản lý chinh nhánh
      state.account.ActionOrder = {
        createOrderThuNo: true,
        createOrderChenhLech: true,
        viewDashBoard: !0,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: state.account.isHeadOfDepartment ? false : true, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: state.account.isHeadOfDepartment ? false : true, // quyền data khách hàng được phép xóa
        permisionBlockCustomer: true, // quyền data khách hàng được phép khóa
        viewPhone: state.account.isHeadOfDepartment ? false : true,
        excelFile: false,
        editDetailProductList: !0,
        // test BranchManager
        alertOrder: !0,
        viewStaffAction: !0,
        viewPrice: !0,
        viewMoreDays: !0,
        editPayOrder: !0,
        editWillPay: !0,
        checkOnFirst: !0,
        viewDetailProductList: !0,
        cancelOrder: !0,
        editTienThucThu: false
      };
      state.account.ActionAccount = {
        // new
        isLocked: true,
        // old
        allowEditOrderComplete: false,
        allowEdit: !0,
        permissionCreate: ['Accountant', 'CustomerService', 'Operating', 'Sale', 'Technician'],
        allowChangeHeadOff: !0
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };
      break;
    case 'Admin':
      state.account.ActionOrder = {
        createOrderThuNo: true,
        createOrderChenhLech: true,
        viewDashBoard: !0,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: !0, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: !0, // quyền data khách hàng được phép xóa
        permisionBlockCustomer: !0, // quyền data khách hàng được phép khóa
        excelFile: true,
        viewMoreDays: !0, // Xem được 31 ngày ở các báo cáo
        // test Admin
        updateOrder: !0,
        reqEditOrder: !0,
        viewStaffAction: !0,
        alertOrder: !0,
        changeVAT: !0,
        viewPrice: !0,
        editPayOrder: !0,
        editWillPay: !0,
        checkOnFirst: !0,
        viewDetailProductList: !0,
        editDetailProductList: !0,
        cancelOrder: !0,
        createOrder: !0,
        editTienThucThu: false,
        reOrder: !0,
        permisionCreate: [
          'Hàng gửi',
          'Lắp mới',
          'Thu phí',
          'Sửa chữa',
          'Bảo hành',
          'Thu đổi',
          'Nâng cấp',
          'Tháo - Lắp lại',
          'ĐL lắp giùm',
          'Lắp giùm ĐL',
          'Thu nợ',
          'Trả hàng'
          // 'Hoàn tiền' // Hoàn tiền
        ],
        defaultOrder: 0, // stt dựa trên list permisionCreate
        checkInWarranty: !0,
        sendFeedback: !0
      };
      state.account.ActionAccount = {
        // new
        isLocked: true,
        // old
        allowEditOrderComplete: true,
        allowEdit: !0,
        permissionCreate: [
          'Accountant',
          'BranchManager',
          'CustomerService',
          'Operating',
          'Sale',
          'Technician',
          'WareHouse'
        ],
        allowChangeHeadOff: !0
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };
      break;

    case 'Root':
      state.account.ActionOrder = {
        createOrderThuNo: true,
        createOrderChenhLech: true,
        viewDashBoard: !0,
        // new
        permissionsCheckTrungBS: !1, // quyền check trùng bs khi tạo đơn
        permisionUpdateCustomer: !0, // quyền data khách hàng được phép sửa
        permisionDeleteCustomer: !0, // quyền data khách hàng được phép xóa
        permisionBlockCustomer: !0, // quyền data khách hàng được phép khóa
        excelFile: true,
        viewMoreDays: !0, // Xem được 31 ngày ở các báo cáo
        // test Root
        updateOrder: !0,
        reqEditOrder: !0,
        viewStaffAction: !0,
        alertOrder: !0,
        changeVAT: !0,
        viewPrice: !0,
        editPayOrder: !0,
        editWillPay: !0,
        checkOnFirst: !0,
        viewDetailProductList: !0,
        editDetailProductList: !0,
        cancelOrder: !0,
        createOrder: !0,
        editTienThucThu: false,
        reOrder: !0,
        permisionCreate: [
          'Hàng gửi',
          'Lắp mới',
          'Thu phí',
          'Sửa chữa',
          'Bảo hành',
          'Thu đổi',
          'Nâng cấp',
          'Tháo - Lắp lại',
          'ĐL lắp giùm',
          'Lắp giùm ĐL',
          'Thu nợ',
          'Trả hàng'
          // 'Hoàn tiền' // Hoàn tiền
        ],
        defaultOrder: 0, // stt dựa trên list permisionCreate
        checkInWarranty: !0,
        sendFeedback: !0
      };
      state.account.ActionAccount = {
        // new
        isLocked: true,
        // old
        allowEditOrderComplete: true,
        allowEdit: !0,
        permissionCreate: [
          'Admin',
          'Accountant',
          'BranchManager',
          'CustomerService',
          'Operating',
          'Sale',
          'Technician',
          'WareHouse'
        ],
        allowChangeHeadOff: !0
      };
      state.account.defaultMenu = {
        keysMenu: 'organized-sales.ordermanager-page',
        openTabs: ['organized-sales.ordermanager-page', 'organized-sales']
      };
      break;

    default:
      break;
  }
};

const initialState: initialStateType = {
  isSuccessLogin: false,
  language: LanguageSelectType.VIETNAM,
  tableSetting: {
    fontSize: '13px',
    sizePage: MINPAGESIZE,
    fontStyle: 'normal',
    stripe: true,
    autoSaveColumnHidden: true,
    autoSaveColumnWidth: true,
    resizingMode: 'widget',
    tableColumnSetting: []
  },
  account: undefined,
  token: Cookies.get('token'),
  roleTag: undefined,
  openSettingTable: false,
  userLoginTest: [],
  deviceTokenMessage: null,
  routesFilter: []
};

const userSlide = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    // resetState: state => {
    //   state.userLogin = undefined;
    // },
    resetState: state => {
      state.userLoginTest = [];
      state.account = undefined;
      state.userAccountTax = false;
    },
    updateToken: (state, action: PayloadAction<any>) => {
      state.token = action.payload;
    },
    updateTableSetting: (state, action: PayloadAction<any>) => {
      const tableSetting = {
        fontSize: action.payload.fontSize,
        sizePage: action.payload.sizePage,
        fontStyle: action.payload.fontStyle,
        stripe: action.payload.stripe,
        autoSaveColumnHidden: action.payload.autoSaveColumnHidden,
        autoSaveColumnWidth: action.payload.autoSaveColumnWidth,
        resizingMode: action.payload.resizingMode,
        tableColumnSetting: state.tableSetting.tableColumnSetting
      };
      state.tableSetting = tableSetting;
    },
    updateSuccessLogin: (state, action: PayloadAction<boolean>) => {
      state.isSuccessLogin = action.payload;
    },
    updateLanguage: (state, action: PayloadAction<LanguageSelectType>) => {
      state.language = action.payload;
      i18.changeLanguage(action.payload === LanguageSelectType.VIETNAM ? 'vn' : 'en');
    },
    // updateUserInfo: (state, action: PayloadAction<{ displayName: string; email: string }>) => {
    //   if (state.account) {
    //     state.account.DisplayName = action.payload.displayName;
    //     state.account.Email = action.payload.email;
    //   }
    // },

    // Trong reducers
    updateUserAccountingPermission: (state, action: PayloadAction<boolean>) => {
      state.canCollectCash = action.payload;

      // Chạy lại lọc route dựa trên cả 2 quyền trong state
      state.routesFilter = handleFilterRouteCanAccess(
        state.account?.role,
        routes,
        state?.account?.role === 'Admin' || state?.account?.role === 'Root' ? true : state.account?.isHeadOfDepartment,
        state.canCollectCash, // Quyền 1
        state.userAccountTax // Quyền 2 (Thêm tham số này vào hàm handleFilter nếu có thể)
      );
    },

    updateUserAccountingPermissionUserAccountTax: (state, action: PayloadAction<boolean>) => {
      state.userAccountTax = action.payload;

      state.routesFilter = handleFilterRouteCanAccess(
        state.account?.role,
        routes,
        state?.account?.role === 'Admin' || state?.account?.role === 'Root' ? true : state.account?.isHeadOfDepartment,
        state.canCollectCash, // Quyền 1
        state.userAccountTax // Quyền 2
      );
    },
    // Xử lý với dữ liệu từ localstorage chuyển thẳng vào ko cần gọi api
    updateUserSlideFromLC: (state, action: PayloadAction<any>) => {
      const response = action.payload;
      // console.log('updateUserSlideFromLC', response);
      // Cập nhật lại listRoute nữa nhé
      state.account = response || {};
      state.roleTag = response?.role || '';
      state.routesFilter = handleFilterRouteCanAccess(
        response?.role,
        routes,
        response?.role == 'Admin' || response?.role == 'Root' ? true : response?.isHeadOfDepartment
      );
      handleAssignRolesAcc(state.roleTag, state);
    },
    // Cập nhật cài đặt style bảng sau khi đăng nhập thành công
    updateTableSettingLogin: (state, action: PayloadAction<TTableSetting>) => {
      if (!action.payload) {
        // console.log("initialState.tableSetting", action.payload)
        state.tableSetting = initialState.tableSetting;
      }
      if (state.tableSetting && action.payload) {
        // console.log("updateTableSettingLogin", action.payload)
        state.tableSetting = action.payload;
      }
    },
    // Cập nhật cài đặt style cho bảng
    updateUserSetting: (
      state,
      action: PayloadAction<{ fontSize: string; sizePage: number; fontStyle: string; stripe: boolean }>
    ) => {
      if (state.tableSetting) {
        state.tableSetting.fontSize = action.payload.fontSize;
        state.tableSetting.fontStyle = action.payload.fontStyle;
        state.tableSetting.sizePage = action.payload.sizePage;
        state.tableSetting.stripe = action.payload.stripe;
      }
    },
    // Cập nhật cột ẩn và cả kích thước cột
    updateColumnSetting: (state, action: PayloadAction<TTableColumnSetting>) => {
      // reset tableColumnSetting list saved
      // state.tableSetting.tableColumnSetting = []
      const indexSetting = state.tableSetting.tableColumnSetting.findIndex(
        item => item.tableName === action.payload.tableName
      );

      // console.log(action.payload.columnSize, action.payload.columnHidden);
      if (indexSetting == -1 && (action.payload.columnHidden.length != 0 || action.payload.columnSize.length != 0)) {
        // console.log('add new');
        state.tableSetting.tableColumnSetting.push(action.payload);
      } else if (action.payload.columnHidden.length == 0 && action.payload.columnSize.length == 0) {
        // console.log('del exist null');
        state.tableSetting.tableColumnSetting.splice(indexSetting, 1);
      } else if (action.payload.columnHidden.length != 0 || action.payload.columnSize.length != 0) {
        // console.log('add exist');
        state.tableSetting.tableColumnSetting = state.tableSetting.tableColumnSetting.map(
          (item: TTableColumnSetting) => {
            if (item.tableName !== action.payload.tableName) {
              return item;
            } else return action.payload;
          }
        );
      }
    },
    updateAutoSaveColumnHidden: (state, action: PayloadAction<{ autoSaveColumnHidden: boolean }>) => {
      if (state.tableSetting) {
        state.tableSetting.autoSaveColumnHidden = action.payload.autoSaveColumnHidden;
      }
    },
    updateOpeSettingTable: (state, action: PayloadAction<boolean>) => {
      // console.log('nhận lệnh', state.openSettingTable, action.payload);
      state.openSettingTable = action.payload;
    },
    updateAccountUser: (state, action: PayloadAction<any>) => {
      // console.log('action.payload', action.payload);
      state.account = {
        ...state.account,
        displayName: action.payload.displayName,
        email: action.payload.email,
        extension: action.payload.extension,
        phone: action.payload.phoneNumber
      };
      // cái này cập nhật vài thứ nhỏ thôi.. displayName email extension phoneNumber
    },
    updateAvatar: (state, action: PayloadAction<any>) => {
      // console.log('action.payload', action.payload);
      state.avatar = action.payload;
      // cái này cập nhật vài thứ nhỏ thôi.. displayName email extension phoneNumber
    },
    updateDeviceTokenMessage: (state, action: PayloadAction<any>) => {
      state.deviceTokenMessage = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(getUserCurrent.fulfilled, (state, action: PayloadAction<any>) => {
      // console.log('getUserCurrent Fulfiled', action.payload);
      state.account = action.payload?.data || {};
      state.roleTag = action.payload?.data?.role || '';
      state.routesFilter = handleFilterRouteCanAccess(
        action.payload?.data?.role,
        routes,
        action.payload?.data?.role == 'Admin' || action.payload?.data?.role == 'Root'
          ? true
          : action.payload?.data?.isHeadOfDepartment
      );

      handleAssignRolesAcc(state.roleTag, state);

      // state.routesFilter = handleFilterRouteCanAccess(action.payload?.User.Role, ROUTER_LIST);
      // cập nhật lại listRoute
    });
  }
});

export const {
  resetState,
  updateToken,
  updateTableSetting,
  updateSuccessLogin,
  updateLanguage,
  updateTableSettingLogin,
  updateUserSetting,
  updateColumnSetting,
  updateAutoSaveColumnHidden,
  updateOpeSettingTable,
  updateAccountUser,
  updateUserSlideFromLC,
  updateUserAccountingPermission,
  updateUserAccountingPermissionUserAccountTax,
  updateDeviceTokenMessage,
  updateAvatar
} = userSlide.actions;

export default userSlide.reducer;
